import React, { useEffect, FC } from 'react';
import { SpecCheckModel } from '../models/specCheck.model';

const SpecCheck: FC<{ model: SpecCheckModel }> = ({ model }) => {
  useEffect(() => {
    const pluginScriptUrl = 'https://lite.speccheck.com/js/plugin.js';
    const knockoutScriptUrl = 'https://cdnjs.cloudflare.com/ajax/libs/knockout/3.4.2/knockout-min.js';
    let specCheckAdditionalProperties = {};
    try {
      const aditionalParametersNormalizedJson = (model.additionalParameters || '{}')
        .replace(/,\s*\}/g, '}')
        .replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2": ');
      specCheckAdditionalProperties = JSON.parse(aditionalParametersNormalizedJson);
    } catch (e) {
      console.error(e);
    }

    const scriptElement = document.createElement('script');

    scriptElement.setAttribute('type', 'text/javascript');

    scriptElement.innerHTML = `
        ///
        /// Pretty self explanitory. Pulls the query strings into something we can use.
        ///
        function getUrlParameter(name) {
            name = name.replace(/[\\[]/, '\\\\[').replace(/[\\]]/, '\\\\]');
            var regex = new RegExp('[\\\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\\+/g, ' '));
        };
        
        ///
        /// helper function so we know when the script is laoded.
        ///
        function loadScript(src, callback) {
            let script = document.createElement('script');
            script.src = src;
            script.onload = () => callback(script);
            document.head.append(script);
        }
        ///
        /// Handles analytics updates based on spec check's page load event. This tweaks spec check's model to something GTM can understand.
        ///
        function analyticsHandler(e) {
            var dataLayerObject = JSON.parse(JSON.stringify(e));
            dataLayerObject.sc = dataLayerObject.state;
            if (dataLayerObject.sc.subject === undefined) { // clear out
                dataLayerObject.sc.subject = {};
                dataLayerObject.sc.subject.manufacturer = undefined;
                dataLayerObject.sc.subject.model = undefined;
        
            }
            if (dataLayerObject.sc.compareTo === undefined || dataLayerObject.sc.compareTo.length === 0) {
                dataLayerObject.sc.compareTo = {};
                dataLayerObject.sc.compareTo.manufacturer = undefined;
                dataLayerObject.sc.compareTo.model = undefined;
        
            } else {
                dataLayerObject.sc.compareTo = {};
                dataLayerObject.sc.compareTo.manufacturer = e.state.compareTo[0].manufacturer;
                dataLayerObject.sc.compareTo.model = e.state.compareTo[0].model;
            }
            if (!dataLayerObject.sc.range) {
                dataLayerObject.sc.range = undefined;
            }
            if (!dataLayerObject.sc.rangePath || (Array.isArray(dataLayerObject.sc.rangePath) && dataLayerObject.sc.rangePath.length == 0)) {
                dataLayerObject.sc.rangePath = undefined;
            }
        
            if (e.event === "page-load" && window.dataLayer) {
                dataLayerObject.event = 'virtualPage';
        
                window.dataLayer.push(dataLayerObject);
        
        
                if (e.state.page === "comparison") {
                    //Safest way to push parameters into a function called via a setTimeout.
                    //Create a function variable, and use .bind(null, variableName);
        
                    var __push = function(dataLayerObjectClone) {
                        window.dataLayer.push(dataLayerObjectClone);
                    };
                    // loop over compareTo array and datalayer push each separately
        
                    for (var i = 0; i < e.state.compareTo.length; i++) {
                        dataLayerObject.event = 'pageAction';
                        dataLayerObject.sc.compareTo = {};
                        dataLayerObject.sc.compareTo.manufacturer = e.state.compareTo[i].manufacturer;
                        dataLayerObject.sc.compareTo.model = e.state.compareTo[i].model;
        
                        setTimeout(__push.bind(null, JSON.parse(JSON.stringify(dataLayerObject))), 200 * i);
                    }
                }
            } else if (window.dataLayer) {
                window.dataLayer.push(dataLayerObject);
        
            } else {
                var retries = 0;
                var interval = setInterval(function() {
                    retries++;
                    if (window.dataLayer) {
                        window.dataLayer.push(dataLayerObject);
                        clearInterval(interval);
                    }
                    if (retries > 10) {
                        clearInterval(interval);
        
                    }
                }, 1000);
            }
        }
        
        function startLoad() {
            loadScript('${pluginScriptUrl}', function() {
                loadScript(['${knockoutScriptUrl}'], function() {
                    var config = {
                        promise: Promise,
                        knockout: window.ko,
                        container: document.querySelector(".speccheck"),
                        embedId:${model.embedId},
                        history: {
                            enabled: true,
                            history: history,
                            window: window
                        },
                        eventHandler: analyticsHandler,
                        ...${JSON.stringify(specCheckAdditionalProperties)}
                    };
                    var startParam = getUrlParameter('start');
                    if (startParam !== '') {
                        if(typeof config.rangeSelection === 'object'){
                            config.rangeSelection.start = startParam
                        } else {
                            config.rangeSelection = {
                                start: startParam
                            };
                        }
                    }
                    var idParam = getUrlParameter('specCheckId');
                    if (idParam !== '') {
                        config.embedId = idParam;
                    }
        
                    window.__specCheck = new SpecCheckLite(config).create();
                });
            });
        }
        startLoad();
    `;

    document.head.appendChild(scriptElement);
  }, []);

  const title = model.title ? model.title : '';

  return (
    <>
      <h2 style={{ textAlign: 'center' }}>{title}</h2>
      <div className="content">
        <div className="speccheck"></div>
      </div>
    </>
  );
};

export default SpecCheck;
